import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Link from "@material-ui/core/Link";
import Grey from "@material-ui/core/colors/grey";
import Icon from "@material-ui/core/Icon";
import DeepOrange from "@material-ui/core/colors/deepOrange";
import AnswerItem from "./answerItem";

const styles = theme => ({
  answerBox: {
    marginTop: theme.spacing.unit * 2,
    marginBottom: theme.spacing.unit,
    fontSize: '16px',
    fontWeight: '600',
    color: Grey[500]
  },
  allReadBox: {
    display: 'flex',
    alignItems: 'center',
    marginTop: theme.spacing.unit,
    fontSize: '14px',
    color: DeepOrange[500]
  }
});
function AnswerBox(props) {
  const answers = props.answers;
  const { classes } = props;
  return (
    <div>
      <div className={classes.answerBox}>
        回答 {answers.acount}
      </div>
      <Grid container spacing={16}>
        { answers.posts.map((post) =>
          <AnswerItem post={post} key={post.id} /> )}
      </Grid>

      <div className={classes.allReadBox}>
        <Icon>chevron_right</Icon>
        <Link href={answers.parentUrl} target="_blank">すべての回答を読む</Link>
      </div>
    </div>
  );
}

AnswerBox.propTypes = {
  answers: PropTypes.object.isRequired
};
export default withStyles(styles)(AnswerBox);
